import { withInstall } from '@lit-element/utils'

import ImageViewer from './src/image-viewer.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtImageViewer: SFCWithInstall<typeof ImageViewer> =
  withInstall(ImageViewer)
export default LtImageViewer

export * from './src/image-viewer'
